import http from '../const/http-common'

const getPresentations = () => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  return http.get('/v1/user/presentation/get', { headers });
}

const createPresentation = (info) => {
  const {title, template_id} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }

  return http.post('/v1/user/presentation/create', {title, template_id}, { headers });
}

const updatePresentation = (info) => {
  const {id, title, template_id} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }

  return http.post('/v1/user/presentation/update', {id, title, template_id}, { headers });
}

const deletePresentation = (info) => {
  const {id} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }

  return http.delete(`/v1/user/presentation/${id}/delete`, { headers });
}

const schedulePresentation = (info) => {
  const {presentation, title, recurrence, day, time, destinations} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }

  return http.post(`/v1/user/presentation/schedule`, {id: presentation, mode: 'presentation', title, recurrence, day, time, destinations}, { headers });
}

const generatePresentation = (info) => {
  const {id} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }

  return http.get(`/v1/user/presentation/${id}/generate`, { headers });
}

const previewSlide = (info) => {
  const {source, prompt} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }

  return http.post('/v1/user/presentation/preview_slide', {source, prompt}, { headers });
}

const createSlide = (info) => {
  const {presentation, title, source, prompt, visualization, comment, x_column, y_column} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }

  return http.post('/v1/user/presentation/create_slide', {presentation, title, source, prompt, visualization, comment, x_column, y_column}, { headers });
}

const updateSlideAxes = (info) => {
  const {presentation, index, x_column, y_column} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  return http.post('/v1/user/presentation/update_slide_axes', {presentation, index, x_column, y_column}, { headers });
}

const updateSlide = (info) => {
  const {presentation, index, title, source, prompt, visualization, comment} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  
  return http.post('/v1/user/presentation/update_slide', {presentation, index, title, source, prompt, visualization, comment}, { headers });
}
const moveSlide = (info) => {
  const {sourceId, sourceIndex, destinationId, destinationIndex} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  
  return http.post('/v1/user/presentation/move', {sourceId, sourceIndex, destinationId, destinationIndex}, { headers });
}

const deleteSlide = (info) => {
  const {id, index} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  
  return http.post('/v1/user/presentation/delete_slide', {id, index}, { headers });
}

const saveWizardPresentation = (info) => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  return http.post('/v1/user/presentation/save_wizard', info, { headers });
}

const getOnePresentation = (id) => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  return http.get(`/v1/user/presentation/${id}/get`, { headers });
}

const updateWizardPresentation = (info) => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  return http.post('/v1/user/presentation/update_wizard', info, { headers });
}

const deleteSchedule = (id) => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  return http.delete(`/v1/user/presentation/${id}/schedule`, { headers });
}

const loadSchedule = (info) => {
  const { id, mode } = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  return http.post('/v1/user/presentation/load_schedule', { id, mode }, { headers });
}

const duplicatePresentation = (info) => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  return http.post('/v1/user/presentation/duplicate', info, { headers });
}

const uploadTemplate = (presentationId, file) => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
  }
  const formData = new FormData()
  formData.append('template', file)
  return http.post(`/v1/user/presentation/upload-template/${presentationId}`, formData, { headers });
}

const testPpt = (templateId, slides) => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json',
  }
  return http.post('/v1/user/presentation/test-ppt', { template_id: templateId, slides }, { headers, responseType: 'blob' })
}

const testSlide = (templateId, slide, slideIndex, decimalPlaces = 2) => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json',
  }
  return http.post(
    '/v1/user/presentation/test-slide',
    { template_id: templateId, slide, slide_index: slideIndex, decimal_places: decimalPlaces },
    { headers, responseType: 'blob' }
  )
}

const regeneratePresentation = (id) => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  return http.post(`/v1/user/presentation/regenerate/${id}`, {}, { headers, responseType: 'blob' });
}

const presentationService = {
  getPresentations,
  createPresentation,
  updatePresentation,
  generatePresentation,
  schedulePresentation,
  deletePresentation,
  previewSlide,
  createSlide,
  updateSlide,
  updateSlideAxes,
  moveSlide,
  deleteSlide,
  saveWizardPresentation,
  getOnePresentation,
  updateWizardPresentation,
  duplicatePresentation,
  deleteSchedule,
  loadSchedule,
  uploadTemplate,
  regeneratePresentation,
  testPpt,
  testSlide,
}

export default presentationService;